<template>
    <loading name="load page">
        <div class="container page fix-footer mt-3">
            <div class="row">
                <div class="col-12 col-md-4">
                    <page-menu :parent="parent" :uri="uri" :user="user"/>
                </div>
                <div class="col-12 col-md-8 clearfix">
                    <div class="main-content padding pt-3" v-if="page">
                        <h3>{{page.title}}</h3>
                        <div v-if="user.editor || user.admin">
                            <span class="dropdown edit-dropdown top-right">
                                <a href="#" data-toggle="dropdown" role="button" aria-expanded="false" aria-haspopup="true"
                                   class="dropdown-toggle" style="" :title="$t('button.Edit')">
                                    <i class="fas fa-pencil-alt big-icon"></i>
                                </a>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <router-link :to="uri + '/edit'" class="dropdown-item">{{ $t('button.Edit') }}</router-link>

                                    <router-link :to="uri + '/create'" class="dropdown-item">{{ $t('button.AddChild') }}</router-link>
                                </div>
                            </span>
                        </div>
                        <div class="content" v-html="page.body"></div>
                    </div>
                </div>
            </div>
        </div>
    </loading>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import PageMenu from '../components/PageMenu.vue';
  import { ROUTER_NAMES } from '@/constants';

  export default {
    name: 'Page',
    components: { PageMenu },
    methods: {
      ...mapActions(['loadPage', 'editPage']),
      findInChild(children) {
        return children.forEach((page) => this.checkPage(page));
      },
      checkPage(page) {
        if (page && page.slug === this.slug) {
          this.filteredPage = page;
        }

        if (page && page.children) {
          this.findInChild(page.children);
        }
      },
      loadActualPage(slug) {
        this.$wait.start('load page');

        this.loadPage({
          slug: slug
        })
          .then(() => this.$wait.end('load page'))
          .catch((e) => {
            const response = e.response ? e.response : {};
            if (response.status == 404) {
              this.$router.push({
                name: ROUTER_NAMES.NOT_FOUND,
                params: {
                  0: ROUTER_NAMES.NOT_FOUND
                }
              });
            } else {
              this.$router.push({
                name: ROUTER_NAMES.ERROR
              });
            }
          });
      }
    },
    data() {
      return {
        filteredPage: {}
      };
    },
    computed: {
      ...mapGetters(['user', 'pages']),
      page() {
        let page = null;
        if (this.parent.children) {
          this.parent.children.forEach((page) => this.checkPage(page));
          page = this.filteredPage;
        }
        return page;
      },
      parent() {
        return this.pages && this.pages[this.parentSlug] ? this.pages[this.parentSlug] : {};
      },
      parentSlug() {
        return this.$route.params.parent;
      },
      slug() {
        return this.$route.params.slug;
      },
      uri() {
        return `/page/${this.parentSlug}/${this.slug}`;
      }
    },
    beforeRouteUpdate(to, f, next) {
      if (to.name === ROUTER_NAMES.PAGE) {
        this.loadActualPage(to.params.parent);
      }
      next();
    },
    created() {
      this.loadActualPage(this.$route.params.parent);
    },
  };
</script>
